import React, { Suspense } from 'react';
import { Grid, Box, Paper, Typography } from '@mui/material';

import { LocalizationContext } from '@cvt/contexts';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { useCompanyCrud } from '../hooks/useCompanyCrud';
import { CompanyForm } from '../partials/CompanyForm';


export const CreateCompany: React.FC = () => {

  const { dictionary } = React.useContext(LocalizationContext);

  const { createCompany } = useCompanyCrud();

  const onSubmit = React.useCallback((data: Companies.Crud) => {
    return createCompany(data);
  }, [createCompany]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography variant="h1">{dictionary.companies.create.title}</Typography>
          </Grid>
          <Grid size={12}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, lg: 8 }}>
                <Box p={4} component={Paper}>
                  <CompanyForm
                    onSubmitRequest={onSubmit}
                    onSubmitButtonText={dictionary.companies.create.buttonCreate}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Suspense>
    </ErrorBoundary>
  );
};
